module.exports = __webpack_public_path__ + "img/U1F4AA.cbc44fd8.png";